var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCloseSmall = function SvgCloseSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.691 8l2.766-2.765a.489.489 0 00-.692-.692L8 7.31 5.235 4.543a.489.489 0 00-.692.692L7.31 8l-2.766 2.765a.489.489 0 10.692.692L8 8.69l2.765 2.766a.489.489 0 10.692-.692L8.69 8z",
    fill: "#fff"
  })));
};
export default SvgCloseSmall;